export const SITE = {
    name: "Vinayak Khare",
    wordmark: "vk.",
    role: "Investment Analysis · Real Estate · Business Strategy",
    location: "Delhi NCR, India",
    email: "vinayakkhare@gmail.com",
    phone: "+91 99991 77300",
    phoneHref: "tel:+919999177300",
    linkedin: "https://www.linkedin.com/in/vinayak-a-khare-3703631a1/",
    resume: "/Vinayak-Khare-CV.pdf",
    portrait: "/vinayak-headshot.jpg",
    portraitAlt: "Vinayak Khare at a podium",
    portraitPos: "50% 6%",
    experienceImage: "/experience-classroom.jpg",
};

export const COLLAB = [
    {
        title: "Development & Advisory",
        line: "Real estate development and advisory for warehousing and corporate leasing across Delhi NCR and Uttar Pradesh.",
    },
    {
        title: "Leasing & Spaces",
        line: "Corporate leasing for e-commerce, education, fitness and international offices — space that fits how a team actually operates.",
    },
    {
        title: "Investment & Strategy",
        line: "A considered, long-term view on businesses and projects — financial analysis, valuation and the discipline to execute.",
    },
];

export const MARQUEE = [
    "Investment Analysis",
    "Real Estate Development",
    "Business Strategy",
    "ISB MBA '23",
    "Vinayak Buildtech",
    "Corporate Leasing & Warehousing",
    "International Banking",
];

export const BIO = [
    [
        {
            t: "I'm Vinayak Khare. I work across investment analysis, real estate and business strategy, bringing a considered, long-term perspective to opportunities that deserve a closer look.",
        },
    ],
    [
        {
            t: "My work sits at the intersection of financial analysis, real estate and execution. I'm interested in the underlying economics of a business, the quality of its decisions and the discipline required to turn a plan into something tangible.",
        },
    ],
    [
        { t: "With an MBA from " },
        { t: "ISB", url: "https://www.isb.edu", testid: "inline-link-isb" },
        {
            t: " and experience spanning international banking and real estate projects, I value clear analysis, thoughtful risk-taking and relationships built on trust. This site brings together my professional interests and a few ways to work together.",
        },
    ],
];

export const EXPERIENCE = [
    {
        id: "buildtech",
        company: "Vinayak Buildtech",
        title: "Promoter / Managing Partner",
        years: "2016 — Present",
        place: "India",
        summary:
            "Co-raised a development and advisory startup — warehousing and corporate leasing across Delhi and Uttar Pradesh, with a tenant roster that includes Flipkart.",
    },
    {
        id: "frost-global",
        company: "Frost Global, Singapore",
        title: "Export Marketing Executive",
        years: "2012 — 2016",
        place: "Singapore",
        summary:
            "A four-year stint straight out of college in the finance sector — fundraising strategy, debt issuance, investor relations and regulatory compliance.",
    },
    {
        id: "education",
        company: "Indian School of Business — MBA, PGPpro",
        title: "Amity Business School — BBA",
        years: "'23 · 2011",
        place: "Education",
        summary:
            "An MBA from ISB after a BBA at Amity Business School — the formal spine behind a practitioner's approach to finance and development.",
    },
];

export const PORTFOLIO = [
    {
        name: "real estate & development",
        blurb: "vinayak buildtech — delhi, haryana & uttar pradesh",
        projects: [
            {
                id: "khare-house",
                title: "Khare House",
                summary:
                    "An apartment complex delivered on time and within budget — managed end-to-end with clients and architects, from plan to handover.",
                meta: ["Apartment Complex", "Completed 2018"],
                image: "/projects/khare-house.jpg",
            },
            {
                id: "vrindavan-apartments",
                title: "Vrindavan Apartments",
                summary:
                    "Phase 2 of our Gurgaon development — expanding the residential footprint in one of NCR's fastest-growing corridors.",
                meta: ["Gurgaon Phase 2", "Commencing 2021"],
                image: "/projects/vrindavan-apartments.jpg",
            },
            {
                id: "shradha-villas",
                title: "Shradha Villas",
                summary:
                    "Six villas spread across three acres — super-luxury fine living in the heart of Lucknow.",
                meta: ["6 Villas · 3 Acres", "Lucknow", "Commenced 2019"],
                image: "/projects/shradha-villas.jpg",
            },
            {
                id: "commercial-ventures",
                title: "Commercial Ventures",
                summary:
                    "Roughly one lakh square feet of commercial assets under management across Delhi, Haryana and Uttar Pradesh — warehousing, corporate leasing and advisory, with tenants including Flipkart.",
                meta: ["~1 Lakh Sq Ft", "Warehousing", "Corporate Leasing"],
            },
        ],
    },
    {
        name: "banking & finance",
        blurb: "four years in singapore's finance sector",
        projects: [
            {
                id: "frost-fundraising",
                title: "Strategic Fundraising Planning",
                summary:
                    "Comprehensive fundraising strategies aligned to growth objectives — debt financing, equity investments and alternative methods, built with senior management and financial experts.",
                meta: ["Frost Global", "Debt", "Equity"],
            },
            {
                id: "frost-debt",
                title: "Debt Issuance",
                summary:
                    "Raising capital through bonds and loans from financial institutions — meticulous financial analysis, risk assessment and negotiation of favourable terms.",
                meta: ["Bonds", "Institutional Loans", "Negotiation"],
            },
            {
                id: "frost-ir",
                title: "Investor Relations & Compliance",
                summary:
                    "Liaison between company and investors — transparent reporting on performance and risk, and fundraising kept squarely within Singapore's regulatory environment.",
                meta: ["Investor Relations", "Compliance", "Singapore"],
            },
        ],
    },
    {
        name: "strategy & community",
        blurb: "leadership beyond the desk",
        projects: [
            {
                id: "isb-pgppro",
                title: "ISB PGPpro '23",
                summary:
                    "Led the executive team organising professional development events — guest speaker sessions, workshops and industry panels for the cohort.",
                meta: ["ISB", "MBA", "Events"],
            },
            {
                id: "amity-association",
                title: "Amity Banking & Finance Association",
                summary:
                    "Elected president representing 300+ finance students; collaborated with the university to establish a dedicated career resource centre.",
                meta: ["President", "300+ Students"],
            },
            {
                id: "golf-charity",
                title: "Golf & Giving Back",
                summary:
                    "Captain of the golf team at the Singapore Indian Chamber; spearheaded a charity drive raising SGD 3,000 for a financial-education nonprofit.",
                meta: ["Golf Captain", "SGD 3,000"],
            },
        ],
    },
];

export const SOCIALS = [
    { name: "LinkedIn", url: SITE.linkedin, testid: "social-link-linkedin" },
    { name: "Resume / CV", url: SITE.resume, testid: "social-link-resume" },
];
